import { CircularProgress, SxProps, Theme, styled } from '@mui/material';
import { PropsWithChildren } from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    loadingContainer: {
        position: 'relative',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
    inheritDisplay: {
        display: 'inherit',
    },
    loadingOverlay: {
        top: 0,
        left: 0,
        zIndex: 1300,
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
    hidden: {
        display: 'none',
    },
    loadingContent: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

const Wrapper = styled('span')(() => ({}));

export interface PoolSpinnerProps {
    enabled?: boolean;
    className?: string;
    overlayColor?: string;
    sx?: SxProps<Theme>;
}

export const PoolSpinner = (props: PropsWithChildren<PoolSpinnerProps>) => {
    const { children, enabled, className, overlayColor, sx } = props;
    const classes = useStyles();

    const containerClass = [className || '', classes.inheritDisplay, enabled ? classes.loadingContainer : ''].join(' ');
    const overlayColorStyle = overlayColor ? { backgroundColor: overlayColor } : {};
    const overlayClass = enabled ? classes.loadingOverlay : classes.hidden;

    return (
        <Wrapper className={containerClass} sx={sx}>
            {/* <Fade in={true}> */}
            <div id="spinner" style={overlayColorStyle} className={overlayClass}>
                <div className={classes.loadingContent}>
                    <CircularProgress />
                </div>
            </div>
            {/* </Fade> */}
            {children}
        </Wrapper>
    );
};
